import { render, staticRenderFns } from "./ChallengeTabHeader.vue?vue&type=template&id=2a96f7ba&scoped=true"
import script from "./ChallengeTabHeader.vue?vue&type=script&lang=js"
export * from "./ChallengeTabHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a96f7ba",
  null
  
)

export default component.exports